// Serialize requests within a resolution: the server replaces its candidate tokens on each lookup.
export const createResolutionRequestGuard = () => {
  let revision = 0;
  let active: number | undefined;

  return {
    begin: () => {
      if (active !== undefined) return undefined;
      active = ++revision;
      return active;
    },
    invalidate: () => {
      revision += 1;
    },
    isCurrent: (request: number) => active === request && revision === request,
    finish: (request: number) => {
      if (active !== request) return false;
      active = undefined;
      return true;
    },
    reset: () => {
      revision += 1;
      active = undefined;
    },
  };
};

type AiOfferState = {
  hasResult: boolean;
  candidateCount: number;
  llmUsed: boolean;
  aiFailed?: boolean;
  manualMode: boolean;
  manualLookupDone: boolean;
};

export const shouldOfferAi = ({ hasResult, llmUsed, aiFailed, manualMode, manualLookupDone }: AiOfferState) =>
  hasResult && (!llmUsed || aiFailed === true) && (!manualMode || manualLookupDone);
